import './footer.scss';
import { Link } from 'react-router-dom';
import logo from '../../assets/img/logo.svg';

const Footer = () => (
  <footer className="site-footer">
    <div className="logo-container">
      <img src={logo} alt="Logo Xerinola" className="logo" />
    </div>
    <nav>
      <Link className="link" to="/support">Ajuda</Link>
      <Link className="link" to="/privacy">Política de privacitat</Link>
      <Link className="link" to="/app">Decarregar</Link>
    </nav>
  </footer>
);

export default Footer;
